export const ImportantEventDateKeys = {
    importantEventDateSkipped: 'importantEventDateSkipped',
};
